import { combineReducers } from 'redux';

import generateReferralLink from './generate-referral-link';
import setRenewalDate from './set-renewal-date';

export default combineReducers({
	setRenewalDate,
	generateReferralLink,
});
